import { render } from "./text-underline.vue?vue&type=template&id=47c86822&scoped=true"
const script = {}

import "./text-underline.vue?vue&type=style&index=0&id=47c86822&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c86822"],['__file',"src/views/other/cssfx/components/text-underline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47c86822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47c86822', __exports__)) {
    console.log('reload')
    api.reload('47c86822', __exports__)
  }
  
  module.hot.accept("./text-underline.vue?vue&type=template&id=47c86822&scoped=true", () => {
    console.log('re-render')
    api.rerender('47c86822', render)
  })

}


export default __exports__